function updateCartItemCount() {
  setTimeout(() => {
    console.log("Starting updateCartItemCount function");
    fetch("/cart.json")
      .then((response) => {
        console.log("Received response from /cart.json:", response);
        return response.json();
      })
      .then((cart) => {
        console.log("Cart data:", cart);
        console.log("COUNT:", cart.item_count);
        const itemCount = cart.item_count;
        const itemCountElement = document.querySelector(
          "span.item-count.center-item-count"
        );
        console.log("COUNT:", cart.item_count);

        if (itemCount > 0) {
          itemCountElement.textContent = itemCount;
          itemCountElement.style.display = "inline";
        } else {
          itemCountElement.style.display = "none";
        }
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  }, "1000");
}

document.addEventListener("click", function (event) {
  if (event.target.id.startsWith("AddToCart")) {
    updateCartItemCount();
  }
});

document.addEventListener("click", function (event) {
  if (event.target.closest('a[title="Remove"]')) {
    updateCartItemCount();
  }
});
